import React from 'react';
export const GlobalContentFooterContext = React.createContext({
    footer: null,
});
